export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const SET_MODAL_CALLBACK_VALUE = "SET_MODAL_CALLBACK_VALUE";
export const SET_MODAL_STATE = "SET_MODAL_STATE";
export const SET_SPINNER_STATUS = "SET_SPINNER_STATUS";